<template>
  <!--
    Centralised page-to-page navigation motion.

    Wrap a <router-view> with v-slot and pass the resolved component +
    route key in so each navigation gets a subtle, fast fade-in:

      <router-view v-slot="{ Component, route }">
        <route-transition :route-key="route.path">
          <component :is="Component" />
        </route-transition>
      </router-view>

    Design choices (see src/styles/css/_motion.css):
    - Subtle opacity crossfade ("route" transition) with `mode="out-in"`:
      the old page fades out fast (no two-page overlap/flicker), the new one
      fades in. Both directions define a real duration — see _motion.css.
    - No spatial movement — page content must never fly in from a corner.
    - Reduced-motion users get a near-instant swap via the global
      prefers-reduced-motion block; no extra handling needed here.
  -->
  <transition name="route" mode="out-in">
    <div :key="routeKey" class="route-transition-host">
      <slot />
    </div>
  </transition>
</template>

<script setup>
  /* eslint-disable no-undef */
  defineProps({
    // A value that changes on navigation (typically `route.path`). Drives
    // the enter transition when the page changes.
    routeKey: {
      type: [String, Number],
      default: '',
    },
  });
</script>

<style scoped>
  .route-transition-host {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
  }
</style>
